import C from "classnames";
import * as React from "react";
export const Label = ({ children, className, testId, htmlFor, required, }) => {
    return (React.createElement("label", { className: C(className && className, "font-weight-bold", {
            required: required,
        }), htmlFor: htmlFor, "data-testid": testId }, children));
};
//# sourceMappingURL=Label.js.map